module.exports = __webpack_public_path__ + "./docs/img/websdk.a68d5ea872ba073d7a7e95760f67b329.svg";